import React from 'react';
import { Hero, Cities, JobsCard, Resources } from '../components';

const Home = () => {
  return (
    <>
      <div className="scroll-smooth">
        <Hero />
        <JobsCard />
        <Cities />
        <Resources />
      </div>
    </>
  );
};

export default Home;
